/**
 * Session Storage tracking voor "Verder winkelen" functionaliteit
 *
 * Dit script houdt bij wat de laatste winkelpagina was die de bezoeker heeft bezocht.
 * Op pagina's die geen cart of checkout zijn, wordt de URL opgeslagen.
 * Op cart/checkout pagina's wordt de waarde niet geüpdatet, zodat de laatste
 * winkelpagina behouden blijft.
 */

(function () {
  'use strict';

  const currentPath = window.location.pathname;
  const isCartPage = currentPath === '/cart' || currentPath.startsWith('/cart/');
  const isCheckoutPage = currentPath.startsWith('/checkouts/') || currentPath.startsWith('/checkout');

  if (!isCartPage && !isCheckoutPage) {
    try {
      sessionStorage.setItem('last_shop_url', window.location.href);
    } catch (e) {
      console.debug('[Cart Continue Shopping] Could not save last shop URL:', e);
    }
  }
})();

/**
 * Zet href op "Verder winkelen"-knop(pen) op basis van last_shop_url (cart/checkout).
 */
function applyContinueShoppingHrefs() {
  'use strict';

  document.querySelectorAll('[data-continue-shopping-button]').forEach((button) => {
    const fallbackUrl = button.getAttribute('data-fallback-url') || button.getAttribute('href') || '';

    try {
      const lastShopUrl = sessionStorage.getItem('last_shop_url');

      if (lastShopUrl) {
        try {
          const lastUrl = new URL(lastShopUrl);
          const currentUrl = new URL(window.location.href);

          if (lastUrl.origin === currentUrl.origin) {
            const lastPath = lastUrl.pathname;
            const isLastCartPage = lastPath === '/cart' || lastPath.startsWith('/cart/');
            const isLastCheckoutPage = lastPath.startsWith('/checkouts/') || lastPath.startsWith('/checkout');

            if (!isLastCartPage && !isLastCheckoutPage) {
              button.setAttribute('href', lastShopUrl);
              return;
            }
          }
        } catch (e) {
          console.debug('[Cart Continue Shopping] Invalid URL in sessionStorage:', e);
        }
      }

      if (fallbackUrl) button.setAttribute('href', fallbackUrl);
    } catch (e) {
      console.debug('[Cart Continue Shopping] Could not read sessionStorage:', e);
      if (fallbackUrl) button.setAttribute('href', fallbackUrl);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyContinueShoppingHrefs);
} else {
  applyContinueShoppingHrefs();
}
